import { gql } from '@apollo/client';

export const CREATE_CART = gql`
  mutation createCart($input: CartInput) {
    cartCreate(input: $input) {
      cart {
        id
        lines(first: 10) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  image {
                    url
                  }
                  title
                  price {
                    amount
                    currencyCode
                  }
                  product {
                    id
                    productType
                    title
                  }
                  sku
                }
              }
            }
          }
        }
        totalQuantity
        cost {
          checkoutChargeAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          subtotalAmountEstimated
          totalAmount {
            amount
            currencyCode
          }
          totalAmountEstimated
          totalDutyAmount {
            amount
            currencyCode
          }
          totalDutyAmountEstimated
          totalTaxAmount {
            amount
            currencyCode
          }
          totalTaxAmountEstimated
        }
      }
    }
  }
`;

export const ADD_TO_CART = gql`
  mutation AddCartLine($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        id
        lines(first: 10) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  image {
                    url
                  }
                  title
                  price {
                    amount
                    currencyCode
                  }
                  product {
                    id
                    productType
                    title
                  }
                  sku
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const REMOVE_FROM_CART = gql`
  mutation RemoveCartLine($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        id
        lines(first: 10) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  image {
                    url
                  }
                  title
                  price {
                    amount
                    currencyCode
                  }
                  product {
                    id
                    productType
                    title
                  }
                  sku
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CART = gql`
  mutation UpdateCartLine($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        id
        lines(first: 10) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  image {
                    url
                  }
                  title
                  price {
                    amount
                    currencyCode
                  }
                  product {
                    id
                    productType
                    title
                  }
                  sku
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CART_NOTES = gql`
  mutation cartNoteUpdate($cartId: ID!, $note: String!) {
    cartNoteUpdate(cartId: $cartId, note: $note) {
      cart {
        # Cart fields
        note
      }
      userErrors {
        field
        message
      }
    }
  }
`;
